<div class="relative flex h-screen overflow-hidden">
  <!-- Sidebar slot: projected by parent -->
  <ng-content select="[sidebar]" />

  <div class="flex h-full flex-1 flex-col overflow-hidden">
    <!-- Top bar -->
    <app-top-bar
      [isSidebarOpen]="sidebarOpen()"
      [showDataspaceDropdown]="showDataspaceDropdown()"
      (toggleSidebar)="toggleSidebar()" />

    <!-- Main content slot -->
    <main class="flex-1 overflow-hidden">
      <ng-content />
    </main>
  </div>

  <!-- Singletons -->
  <app-notification-container />
  <app-overlay-host />
</div>
